import { ERROR_CONFIG_SEPARATOR } from '@/auth/types';

type ExtractErrorKeyAndMessage = {
  errorKey: string;
  defaultErrorMessage: string;
};

export const extractErrorKeyAndMessage = (
  errorConfig: string
): ExtractErrorKeyAndMessage => {
  const fallbackData = { errorKey: '', defaultErrorMessage: '' };

  if (!errorConfig) return fallbackData;

  const index = errorConfig.indexOf(ERROR_CONFIG_SEPARATOR);

  if (index === -1) return fallbackData;

  return {
    errorKey: errorConfig.substring(0, index).trim(),
    defaultErrorMessage: errorConfig
      .substring(index + ERROR_CONFIG_SEPARATOR.length)
      .trim(),
  };
};
